import React from "react";
import BrandSpinner from "./BrandSpinner";

export default function RouteLoader({ label = "Loading..." }) {
  return <BrandSpinner label={label} />;
}
